import { InitSnackBarAction } from "./action";
import { initSnackBardState, SnackBarState } from "./state";


export function SnackBarOpenReducer (state:SnackBarState = initSnackBardState, action: InitSnackBarAction):SnackBarState{

    switch (action.type) {
        case '@@OpenSnackBar/SUCCESS':
            return {
                ...state,
                isSuccess:action.isSuccess,
                openSnackBar:action.openSnackBar,
                message:action.message
            }
            
        case'@@CloseSnackBar':
            return {
                ...state,
                isSuccess:action.isSuccess,
                openSnackBar:action.openSnackBar,
                message:action.message
            }

            default:
                return state
    }




}